<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="head_1"><b>CHAPTER 1</b></p>
<p class="noindent">“There it is! That’s his house. He stole my dog!”</p>
<p class="indent">Krista Brody held tight to her young son’s hand. He was understandably upset, since his new puppy was involved. “Why don’t we go knock on the man’s door and ask him?” she suggested.</p>
<p class="indent">“No, Mom!” Bobby tugged on her. “He’s real mean. My friend Josh said.”</p>
<p class="indent">“Nonsense. Just because we haven’t met all our neighbors yet doesn’t make this one some kind of a monster.</p>
<p class="indent">“He is so.”</p>
<p class="indent">Krista bent down to meet her son on his level. “We have to introduce ourselves and ask the man if he’s seen Puddles. You want to find your puppy, don’t you?”</p>
<p class="indent">“Uh-huh.”</p>
<p class="indent">“Then we have to look everywhere. Including this house.”</p>
<p class="indent">Tears were pooling in the child’s blue eyes. Krista’s heart ached for him. Getting Bobby the black-and-white pup had been her latest attempt at helping her son feel loved and accepted. Most of the children in Serenity had known each other all their lives. Bobby was clearly an outsider, even though his paternal grandparents still lived on the farm where his father had grown up.</p>
<p class="indent">She straightened. “Trust me, honey. I’m just going to knock on the door and ask whoever lives there if they’ve seen Puddles. Okay?”</p>
<p class="indent">The child nodded solemnly. “I’ll go, too. I won’t let him be mean to you.”</p>
<p class="indent">“Good,” Krista said, smiling. “I like having a strong man around for protection.”</p>
<p class="indent">“Like Dad was?”</p>
<p class="indent">“Yes, honey, like your daddy.”</p>
<p class="indent">“Why did he have to go to heaven?”</p>
<p class="indent">Answering the child’s questions about his father’s death was getting easier now that several years had passed since Len’s accident. “Your daddy was driving too fast. He wasn’t being careful.” And he left me with a child to raise all by myself, she added silently, stifling a surge of exasperation.</p>
<p class="indent">“Dad would go get Puddles for me if he was here, huh?”</p>
<p class="indent">“Yes,” Krista assured him. “But since he can’t, I’ll help you.”</p>
<p class="indent">“You gonna beat that guy up? He’s pretty big, Mom.”</p>
<p class="indent">Krista stifled a laugh. “I don’t think it’ll be necessary to fight anybody for your puppy, Bobby. Puddles probably wandered off, that’s all.”</p>
<p class="indent">“Hey! What if he went to Gramma Brody’s farm?”</p>
<p class="indent">“Puddles has only been missing since you let him out to play after school. He couldn’t possibly have run that far in such a short time.”</p>
<p class="indent">Krista led Bobby up the front steps of the modest brick house, then paused. There was no homey lawn furniture on this porch. Though the yard was well-kept, it too lacked a personal touch.</p>
<p class="indent">Beside her, Bobby tugged on her hand. “You scared, Mama?”</p>
<p class="indent">“No, honey.” The front door stood ajar. She knocked on the frame of the screen and called, “Hello? Anybody home?”</p>
<p class="indent">Heavy footsteps echoed inside the house. Determined to make a good first impression, she smiled broadly.</p>
<p class="indent">The steps halted. The door swung open. A tall man with dark, tousled hair and a disconcerted expression confronted her. “Yes?”</p>
<p class="indent">“We’re sorry to bother you, Mr....”</p>
<p class="indent">The rest of her words stuck in her throat the moment she looked into his eyes. Dark, inviting eyes. Familiar eyes. Eyes that had once sparkled with the joy of life and made her pulse dance when he spoke her name.</p>
<p class="indent">Eyes that had peered so deeply into her soul she’d almost called off her engagement to the man who was to become Bobby’s father.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369700407_Chapter_1.vue?08e18239